import React from 'react';
import { translate } from 'react-jhipster';
import { Button } from 'reactstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';

export const ResendSmsDialog = ({
  openResendSmsDialog,
  handleResendSmsClose,
  resendSmsType,
  resendSmsStatus,
  resendSmsError,
  quotationEntity,
}) => {
  const isSuccess = resendSmsStatus === 'success';

  return (
    <Dialog open={openResendSmsDialog} onClose={handleResendSmsClose}>
      <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {isSuccess ? (
          <>
            <CheckIcon style={{ color: '#4caf50' }} />
            {translate('comexApp.quotation.resendSMS.smsSuccess')}
          </>
        ) : (
          <>
            <ClearIcon style={{ color: '#f44336' }} />
            {translate('comexApp.quotation.resendSMS.smsError')}
          </>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'black' }} className="mb-3">
          {isSuccess ? (
            resendSmsType === 'transfer' ? (
              translate('comexApp.quotation.resendSMS.resendSmsTransferSuccess', {
                quotationNo: <b>{quotationEntity?.id?.toString()}</b>,
                phoneNumber: <b>{quotationEntity?.customer?.tel || 'N/A'}</b>,
              })
            ) : (
              translate('comexApp.quotation.resendSMS.resendSmsSoldSuccess', {
                quotationNo: <b>{quotationEntity?.id?.toString()}</b>,
                phoneNumber: <b>{quotationEntity?.customer?.tel || 'N/A'}</b>,
              })
            )
          ) : (
            <div>
              <div style={{ marginBottom: '8px' }}>
                {resendSmsType === 'transfer'
                  ? translate('comexApp.quotation.resendSMS.resendSmsTransferError', {
                      quotationNo: <b>{quotationEntity?.id?.toString()}</b>,
                      phoneNumber: <b>{quotationEntity?.customer?.tel || 'N/A'}</b>,
                    })
                  : translate('comexApp.quotation.resendSMS.resendSmsSoldError', {
                      quotationNo: <b>{quotationEntity?.id?.toString()}</b>,
                      phoneNumber: <b>{quotationEntity?.customer?.tel || 'N/A'}</b>,
                    })}
              </div>
              {resendSmsError && (
                <div
                  style={{
                    color: '#f44336',
                    fontSize: '0.9em',
                    fontStyle: 'italic',
                    marginTop: '8px',
                    padding: '8px',
                    backgroundColor: '#ffebee',
                    borderRadius: '4px',
                  }}
                >
                  <strong>{translate('comexApp.quotation.resendSMS.errorDetails')}:</strong> {resendSmsError}
                </div>
              )}
            </div>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="mx-3">
        <Button color={isSuccess ? 'primary' : 'secondary'} onClick={handleResendSmsClose} autoFocus>
          {translate('comexApp.quotation.okButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
